module.exports = __webpack_public_path__ + "img/ins-banner-catalogue.0034385f.svg";